import React, { useState, useEffect } from 'react';
import { Row, Col, Accordion, Card, Button, Container, Dropdown } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { getPlayerDescriptions, updateCharacterBiography } from '../../components/deityRequests';
import ColouredText from '../../components/ColouredText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { descriptionTypes } from './PlayerDescriptionEditor';

const PlayerCurrentDescription = ({ descriptionType, defaultUsername, activeDescriptionCode, currentDescription, descriptions, selectActiveDescription }) => {
    const [playerName, setPlayerName] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        setPlayerName(defaultUsername);
        setDescription(currentDescription);

    }, [defaultUsername, currentDescription]);

    let textRows = 2;
    if (descriptionType > 0)
        textRows = 12;

    return (
        <Card className={"m-4 p-1"} >
            <Row className="row fluid align-content-center mx-2 px-2">
                <h3>
                    Current Description
                </h3>
            </Row>
            <Row className="row fluid align-content-center mx-2 p-2">
                <Col xl={2}>
                    <Dropdown >
                        <Dropdown.Toggle variant="tool" id="dropdown-basic">
                            {activeDescriptionCode}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>

                            {descriptions.sort((a, b) => a.descriptionId > b.descriptionId ? 1 : -1).map((entry, index) =>
                                <Dropdown.Item key={index} onClick={() => selectActiveDescription(entry.descriptionId)}>{entry.descriptionId}</Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>

                </Col>
                <Col lg>
                    <ColouredText ColouredText={currentDescription} />
                </Col>
            </Row>

        </Card>
    );

}

export default PlayerCurrentDescription;